<template>
  <div>
    <CRUDCriteria :showReset="true" :showSearch="false" :showAdditionalActions="true">
      <template v-slot:criteriaRows>
        <div class="mt-0 ml-6 mr-6 mb-0 pa-0">
          <v-row class="row">
            <v-col cols="2" class="pt-0 pb-0">
              <CommonDropDowns :isItTaxYear=true @change="dataFromCommonDropDowns"
                  :criteriaState="criteriaState" />
            </v-col>
            <v-col cols="2" class="pt-0 pb-0">
              <v-text-field class="input-text-size" v-model.number="criteriaState.taxId"
                @input="searchByTimeOut" label="Tax Id" />
            </v-col>
            <v-col cols="3" class="pt-0 pb-0">
              <MultiItemSelect
                label="Category"
                itemText="name"
                itemValue="value"
                :itemList="commentsCategory"
                :items="criteriaState.category || []"
                @selected-items="dataFromCommonDropDowns($event, 'category')"
              />
            </v-col>
            <v-col cols="5" class="pt-0 pb-0">
              <v-text-field class="input-text-size"
                v-uppercase=globalSettingItem.conEverythingToCaps
                v-model="criteriaState.wildcard"
                @input="wildcardSearchDelayed"
                autocomplete="off"
              >
                <template v-slot:label>
                  <label>Wildcard search (comments) </label>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row class="row pt-0 mt-n6">
            <v-col cols="2" class="pt-0 pb-0">
              <ClarionDateControl class="input-text-size"
                v-model="criteriaState.fromDate" @input="searchByTimeOutClarionDate"
                :isToggle="false" label="From Date" />
            </v-col>
            <v-col cols="2" class="pt-0 pb-0">
              <ClarionDateControl class="input-text-size"
                v-model="criteriaState.toDate" @input="searchByTimeOutClarionDate"
                :isToggle="false" label="To Date" />
            </v-col>
            <v-col v-if="showStatusCodes" cols="4" class="pt-0 pb-0">
              <MultiItemSelect
                label="Status Codes"
                itemText="name"
                itemValue="value"
                :itemList="statusCodeItems"
                :items="criteriaState.statusCodes || []"
                @selected-items="dataFromCommonDropDowns($event, 'statusCodes')"
              />
            </v-col>
            <v-col :cols="showStatusCodes ? 4 : 6" class="pt-0 pb-0">
              <v-text-field class="input-text-size"
                v-model="criteriaState.excludePattern"
                @input="searchByTimeOut"
                label="Exclude pattern (comments)"
                autocomplete="off"
                clearable
              />
            </v-col>
          </v-row>
        </div>
      </template>
      <template v-slot:additionalActions >
        <v-row class="align-center">
          <v-col cols="auto">
            <v-btn class="input-text-size" text color="blue darken-1"
             @click="printSelectedComment">
              Print Selected Comments
            </v-btn>
          </v-col>
          <v-col cols="auto">
            <v-btn class="input-text-size" text color="blue darken-1" @click="printComment">
              Print Comments
            </v-btn>
          </v-col>
          <v-col cols="auto">
            <AddToCronJobBtn
              destination="taxInquiry/comments"
              :params="cronParams"
            />
          </v-col>
        </v-row>

      </template>
    </CRUDCriteria>
  </div>
</template>

<script>
import {
  mapGetters, mapState, mapMutations, mapActions,
} from 'vuex';
import ClarionDateControl from '@/components/common/ClarionDateControl.vue';
import CommonDropDowns from '../common-utils/CommonDropDowns.mixin.vue';
import { clients } from '../../../util/clients';
import { getRawJwt } from '../../../util/jwt';
import CRUDCriteria from '../../common/base/crud-2.0/CRUDCriteria.vue';
import { makeCriteriaStateNullIfEmptyString } from '../common-utils/CommonTaxFunctionalities';
import { SEARCH_DEBOUNCE_TIMER } from '../common-utils/constants';
import GlobalToCaps from '../../../util/shared/GlobalToCaps.mixin.vue';
import AddToCronJobBtn from '../../common/AddToCronJobBtn.vue';
import MultiItemSelect from '../../common/base/MultiItemSelect.vue';

const { backendRest } = clients.direct;

export default {
  name: 'commentCriteria',
  mixins: [GlobalToCaps],
  components: {
    CRUDCriteria,
    CommonDropDowns,
    ClarionDateControl,
    AddToCronJobBtn,
    MultiItemSelect,
  },
  props: {
    baseCrudKey: {
      type: String,
      default: 'default',
    },
  },
  data() {
    return {
      delayTimerId: undefined,
    };
  },

  computed: {
    ...mapGetters('tax/taxComments', ['selectedCriteria', 'taxYearList']),
    ...mapGetters('base/crud', ['criteria', 'items']),
    ...mapState({
      taxYearList: (state) => state.tax.taxCommon.taxYearList,
      storeSelectItems: (state) => state.tax.taxComments.selectedItems,
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
      commentsCategory: (state) => (state.base.crud.items.sharedTaxComments || []).filter((c) => c.value !== null),
      taxStatusCodesList: (state) => state.shared.taxStatusCodesShared.taxStatusCodes || [],
    }),
    showStatusCodes() {
      return (this.criteriaState.category || []).includes(2);
    },
    statusCodeItems() {
      return (this.taxStatusCodesList || []).map((sc) => ({
        value: sc.statusCode,
        name: sc.description ? `${sc.statusCode} - ${sc.description}` : String(sc.statusCode),
      }));
    },
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    cronParams() {
      return this.buildCriteriaParams();
    },
  },
  watch: {
    showStatusCodes(val) {
      if (val && this.taxStatusCodesList.length === 0) {
        this.loadTaxStatusCodesSharedRecords({
          isItSetState: true,
          criteria: { skip: 0, limit: 100, sortBy: [{ column: 'statusCode', direction: 'asc' }] },
        });
      }
    },
  },
  methods: {
    ...mapMutations('base/crud', [
      'setCriteria',
    ]),
    ...mapActions('shared/taxStatusCodesShared', ['loadTaxStatusCodesSharedRecords']),
    buildCriteriaParams() {
      const c = this.criteriaState || {};
      const p = {};
      if (c.taxYear) p.taxYear = c.taxYear;
      if (c.fromDate) p.fromDate = c.fromDate;
      if (c.toDate) p.toDate = c.toDate;
      if (c.category && (Array.isArray(c.category) ? c.category.length > 0 : true)) {
        p.category = Array.isArray(c.category) ? c.category.join(',') : c.category;
      }
      if (c.wildcard) p.wildcard = c.wildcard;
      if (c.taxId) p.taxId = c.taxId;
      if (c.excludePattern) p.excludePattern = c.excludePattern;
      if (c.statusCodes && c.statusCodes.length > 0) {
        p.statusCodes = c.statusCodes.join(',');
      }
      return p;
    },
    dataFromCommonDropDowns(val, whichField) {
      this.criteriaState[whichField] = val;
      this.searchByCriteria();
    },
    handleLoadCRUDList(criteriaArgs = {}) {
      this.$emit('loadCRUDList', criteriaArgs);
    },
    searchByCriteria() {
      const returnCriteria = makeCriteriaStateNullIfEmptyString(this.criteriaState);
      this.criteriaState = { ...returnCriteria };
      this.handleLoadCRUDList();
    },
    getAuthToken() {
      return getRawJwt();
    },
    wildcardSearchDelayed() {
      clearTimeout(this.delayTimerId);
      this.delayTimerId = setTimeout(async () => {
        const criteriaArgs = { searchMode: 'wildcard' };
        await this.handleLoadCRUDList(criteriaArgs);
      }, SEARCH_DEBOUNCE_TIMER);
    },
    urlEncodeObject(obj) {
      return new URLSearchParams(obj).toString();
    },
    openCommentsReport(extraParams) {
      const criteria = { ...this.buildCriteriaParams(), token: this.getAuthToken(), ...extraParams };
      const urlCriteria = this.urlEncodeObject(criteria);
      const toUrl = `${backendRest.defaults.baseURL}/taxInquiry/comments?${urlCriteria}`;
      window.open(toUrl);
    },
    printSelectedComment() {
      const slectedObj = this.storeSelectItems.filter((el) => typeof el === 'object');
      const _ids = slectedObj.map((item) => item._id);
      const selectedIds = _ids.join();
      if (!selectedIds) {
        return;
      }
      this.openCommentsReport({ _ids: selectedIds });
    },
    printComment() {
      const _ids = this.items(this.baseCrudKey).map((item) => item._id);
      if (_ids.length < 1) {
        return;
      }
      this.openCommentsReport({ _ids: _ids.join() });
    },
    searchByTimeOut() {
      clearTimeout(this.delayTimerId);
      this.delayTimerId = setTimeout(async () => {
        this.searchByCriteria();
      }, SEARCH_DEBOUNCE_TIMER);
    },
    searchByTimeOutClarionDate(val) {
      clearTimeout(this.delayTimerId);
      if ((val && (val).includes('-')) || !val) {
        this.delayTimerId = setTimeout(async () => {
          this.searchByCriteria();
        }, SEARCH_DEBOUNCE_TIMER);
      }
    },
  },
};
</script>
<style scoped>
.rightAlign {
  float: right;
}
</style>
